import Collateral from "./Collateral";

export default Collateral;
